import React, { useState, useEffect } from 'react';
import {
    Card,
    CardBody,
    Button,
    ButtonGroup,
    Form,
    CustomInput,
    FormGroup,
    Input,
    Tooltip
} from 'reactstrap';

import { Separator } from '../../../../../../components/common/CustomBootstrap';

let arr = [];
export default function ComingSoon({
    label,
}) {
    return <Card className="mb-4"> <CardBody>
        <div className="text-center">
            <h6>
                {label} (Coming Soon)
            </h6>
        </div>
        <Separator className="mb-3" />
    </CardBody></Card>;
}
